import { render, staticRenderFns } from "./Rekisteroi-kayttaja-kiitos.vue?vue&type=template&id=6157e685&"
import script from "./Rekisteroi-kayttaja-kiitos.vue?vue&type=script&lang=js&"
export * from "./Rekisteroi-kayttaja-kiitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports